import { ReactElement } from 'react';
import { Link as MLink, LinkProps as MLinkProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface LinkProps extends MLinkProps {
  to: string;
  children: ReactElement;
}

export const Link = ({ to, children, ...props }: LinkProps) => {
  const navigate = useNavigate();

  const onClickLik = (e: any) => {
    if (props.download) return;
    e.preventDefault();
    navigate(to);
    props?.onClick && props.onClick(e);
  };

  return (
    <MLink {...props} href={to} onClick={onClickLik}>
      {children}
    </MLink>
  );
};
